import {MutationTree} from "vuex";
import {StageState} from "../types/StageState";
import { State as StateStageEnum } from "@share/program/types/StageState"

export const mutations: MutationTree<StageState> = {
    setState(state, payload: StateStageEnum) {
        state.state = payload;
    },
    setSessionsForAnnonce(state, payload: any[]) {
        state.sessionsForAnnonce = payload;
    },
    setUpcomingSessions(state, payload: any[]) {
        state.upcomingSessions = payload;
    }
}